import axios from 'axios';
import { API_BASE } from './apiBase';
const API_BASE_URL = API_BASE;

// Fonction utilitaire pour obtenir les headers avec authentification
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  const headers = {};

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};

/**
 * Configuration du mode de récupération des leads
 * - 'traditional': Utilise l'API traditionnelle /api/leads
 * - 'hybrid': Utilise la nouvelle API hybride /api/leads-hybrid
 */
const LEADS_MODE = process.env.REACT_APP_LEADS_MODE || 'hybrid';

// Fonction pour récupérer tous les leads (avec support hybride)
export const getAllLeads = async () => {
  try {
    console.log(`🔍 getAllLeads - Mode: ${LEADS_MODE}`);
    
    const endpoint = LEADS_MODE === 'hybrid' ? '/leads-hybrid' : '/leads';
    const response = await axios.get(`${API_BASE_URL}${endpoint}`, {
      headers: getAuthHeaders()
    });

    const data = response.data;

    // Ajouter des métadonnées sur la source
    if (data?.success && data.data) {
      console.log(`✅ ${data.data.count} leads récupérés (source: ${data.data.source || 'unknown'})`);

      if (data.data.sources) {
        console.log('📊 Détail des sources:', data.data.sources);
      }
    }

    return data;
  } catch (error) {
    console.error('❌ Erreur API getAllLeads:', error);

    if (LEADS_MODE === 'hybrid') {
      console.warn('🔄 Fallback vers le mode traditionnel...');
      try {
        return await getAllLeadsTraditional();
      } catch (fallbackError) {
        console.error('❌ Échec du fallback traditionnel:', fallbackError);
        throw error;
      }
    }

    throw error;
  }
};

// Fonction traditionnelle pour récupérer les leads (fallback)
const getAllLeadsTraditional = async () => {
  console.log('🔍 getAllLeadsTraditional - Mode de récupération traditionnel');
  const response = await axios.get(`${API_BASE_URL}/leads`, {
    headers: getAuthHeaders()
  });

  const data = response.data;
  
  // Normaliser la réponse pour qu'elle soit cohérente avec le format hybride
  if (data.success && data.data) {
    if (!data.data.source) {
      data.data.source = 'database_traditional';
    }
    console.log(`✅ ${data.data.count} leads récupérés (mode traditionnel)`);
  }
  
  return data;
};

// Fonction pour créer un nouveau lead
export const createLead = async (leadData) => {
  try {
    console.log('🔍 createLead - Données reçues:', leadData);
    
    // Adapter les noms de champs pour le backend
    const backendData = {
      ...leadData,
      reference_details: leadData.referenceDetails // Mapper vers le nom attendu par le backend
    };
    
    // Retirer le champ frontend
    delete backendData.referenceDetails;
    
    console.log('📤 createLead - Données adaptées pour le backend:', backendData);

    const response = await fetch(`${API_BASE_URL}/leads`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(backendData)
    });

    if (!response.ok) {
      const errorData = await response.json();
      
      // Gestion spécifique des erreurs d'authentification
      if (response.status === 401) {
        const message = errorData.message || '';
        if (message.includes('Token expiré') || message.includes('Token expired')) {
          throw new Error('Votre session a expiré. Veuillez vous reconnecter.');
        }
        throw new Error('Erreur d\'authentification. Veuillez vous reconnecter.');
      }
      
      throw new Error(errorData.message || 'Erreur lors de la création du lead');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Erreur API createLead:', error);
    throw error;
  }
};

// Fonction pour convertir un lead en client
export const convertLeadToClient = async (leadId, utilisateur, notes) => {
  try {
    const response = await fetch(`${API_BASE_URL}/leads/${leadId}/convert-to-client`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        utilisateur,
        notes
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Erreur lors de la conversion');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Erreur API convertLeadToClient:', error);
    throw error;
  }
};

// Fonction pour récupérer l'historique des conversions
export const getConversionHistory = async (limit = 50) => {
  try {
    const response = await fetch(`${API_BASE_URL}/leads/conversion-history?limit=${limit}`, {
      headers: getAuthHeaders()
    });
    
    if (!response.ok) {
      throw new Error('Erreur lors de la récupération de l\'historique');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Erreur API getConversionHistory:', error);
    throw error;
  }
};
